<template>

  <v-dialog
    :value="visiblePopup"
    :max-width="330"
    @click:outside="onOkClickButton"
    @keydown.esc="onOkClickButton"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class="message">{{$t(message)}}</div>
      <div class='data' v-if='data'> {{ data }}</div>
      <div class="buttons">
        <v-btn small depressed class="no-button btn-primary" @click="onOkClickButton()">
          {{okCaption}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>

import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'MessagePopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    message: String,
    okCaption: String,
    visiblePopup: {
      type: Boolean,
      required: true,
    },
    data: String,
  },
  methods: {
    onOkClickButton() {
      this.$emit('clicked');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/design-system';

  .popup-wrapper {
    max-width: rem(380);
    padding: $space-8 $space-10;

    .title {
      color: var(--text-primary);
      font-size: $font-size-sm;
      font-weight: 600;
      letter-spacing: 1.12px;
      line-height: $space-4;
      text-transform: uppercase;
      padding-bottom: rem(23);
      white-space: nowrap;
    }

    .data .message {
      font-size: $font-size-base;
      line-height: 1.36;
      font-weight: normal;
      color: var(--text-primary);
      letter-spacing: 0;
      line-height: rem(18);
    }

    .buttons {
      text-align: right;
      padding-top: rem(30);

      .no-button {
        box-sizing: border-box;
        height: $btn-height-md;
        width: rem(86);
        border-radius: $radius-sm;
        box-shadow: $shadow-sm;
        font-size: $font-size-sm;
        font-weight: 500;
        letter-spacing: 1.07px;
        line-height: $space-4;
        text-align: center;
      }

    }
  }

</style>
